import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { action } from 'satcheljs';

export let initializeCalendarEvents = action(
    'initializeCalendarEvents',
    (originalEvent: CalendarEvent, eventUpdates?: Partial<CalendarEvent>) => ({
        originalEvent,
        eventUpdates,
    })
);
